import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-listfinance',
  templateUrl: './listfinance.component.html',
  styleUrls: ['./listfinance.component.scss']
})
export class ListfinanceComponent implements OnInit {
  monthYear: { month: string, year: string}[] = [];
  offices: {id: number, name: string, address: string, start: string, end: string}[] = [];
  officeId: string = '';
  breadcrumbs: {name: string, path?: string, link: boolean}[] = [];
  currentOfficeId: number = 0;

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    this.breadcrumbs = [
      {
        name: 'Agenda',
        path: '/dashboard/new-calendar',
        link: true,
      },
      {
        name: 'Reporte de Finanzas',
        link: false,
      },
    ];

    this.getRecordsData();
    this.getOffices();
  }

  getRecordsData(): void {
    this.api.get('finance').subscribe({
      next: data => {
        this.monthYear = data.data;
        this.officeId = data.officeId;
      },
      error: err => {}
    })
  }

  getOffices() {
    this.api.get('offices').subscribe({
      next: (offices) => {
        this.offices = offices.offices;
      },
      error: (err) => {},
    });
  }

  setCurrentOffice(evt: any) {
    this.api.get(`finance/${evt.target.value}`).subscribe({
      next: (data) => {
        this.monthYear = data.data;
        this.officeId = data.officeId;
      },
      error: (err) => {},
    });
  }

  clearSearch() {
    this.currentOfficeId = 0;
    this.getRecordsData();
  }

  reloadInfo() {
    this.getRecordsData();
    this.getOffices();
  }
}
